<template>
  <UISelect
    :api="apiSearch"
    placeholder="Selectionner un produit"
    search-placeholder="Chercher un produit..."
    :modelValue="value"
    @update:modelValue="changed"
    @selected="$emit('selected', $event)"
  />
</template>

<script>
import { ref } from 'vue'
import useApi from '@/hooks/useApi'
import UISelect from '@/components/UI/Atom/Select'

export default {
  props: {
    alle: Boolean,
    multiple: Boolean,
    modelValue: Object,
  },
  components: {
    UISelect,
  },
  emits: ['update:modelValue', 'selected'],
  setup(props, { emit }) {
    let value = ref(props.modelValue)
    const api = useApi()
    const changed = chauffeur => {
      emit('update:modelValue', chauffeur)
    }
    return { apiSearch: api.products.search, changed, value }
  },
}
</script>

<style></style>
